webpackJsonp([4],{

/***/ "GXjT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/system/inSchool.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//引入底部子组件
// import Banner from '../layout/banner'
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
/* harmony default export */ var inSchool = ({
  metaInfo: {
    title: '校内教育--金成英特教育', // set a title
    meta: [{ // set meta
      name: '校内教育--金成英特教育'
    }]
  },
  name: 'inSchool',
  data: function data() {
    return {};
  },
  created: function created() {},

  computed: {},
  mounted: function mounted() {
    var that = this;
    if (this.$route.query.type) {
      this.$emit('typeChange', this.$route.query.type);
    }
  },

  methods: {
    toClick: function toClick(index) {
      console.log('/' + this.$store.state.language + '/kindergarten');
      switch (index) {
        case 0:
          this.$router.push({
            path: '/' + this.$store.state.language + '/kindergarten'
          });
          break;
        case 1:
          this.$router.push({
            path: '/' + this.$store.state.language + '/smallSchool'
          });
          break;
        case 2:
          this.$router.push({
            path: '/' + this.$store.state.language + '/middleSchool'
          });
          break;
        default:
          break;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-60f3d05d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/system/inSchool.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inSchool"},[_c('div',{staticClass:"title_style"},[_vm._v(_vm._s(_vm.$t("educationSystem.bread.first")))]),_vm._v(" "),_c('div',{staticClass:"kinder_style"},[_c('img',{staticClass:"kinder_imgTop_style",attrs:{"src":_vm.$t("educationSystem.imgArr")[0]}}),_vm._v(" "),_c('div',{staticClass:"kinder"},[_c('div',{staticClass:"kinder_title_style"},[_c('div',{staticClass:"kinder_title_style_item",attrs:{"title":_vm.$t("educationSystem.schoolEducation.firstArr")[0].title}},[_vm._v(_vm._s(_vm.$t("educationSystem.schoolEducation.firstArr")[0].title))])]),_vm._v(" "),_c('div',{staticClass:"kinder_content"},[_c('div',{staticClass:"kinder_content_style",attrs:{"title":_vm.$t("educationSystem.schoolEducation.firstArr")[0].content}},[_vm._v(_vm._s(_vm.$t("educationSystem.schoolEducation.firstArr")[0].content))]),_vm._v(" "),_c('div',{staticClass:"kinder_design_style1"},[_c('span',{staticClass:"kinder_design_title_style"},[_vm._v("\n            "+_vm._s(_vm.$t("educationSystem.bread.second"))+"\n          ")]),_vm._v(" "),_c('span',{attrs:{"title":_vm.$t("educationSystem.bread.second_content")}},[_vm._v("\n            "+_vm._s(_vm.$t("educationSystem.bread.second_content"))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"kinder_design_style"},[_c('span',{staticClass:"kinder_design_title_style"},[_vm._v("\n            "+_vm._s(_vm.$t("educationSystem.bread.three"))+"\n          ")]),_vm._v(" "),_c('span',{attrs:{"title":_vm.$t("educationSystem.bread.three_content")}},[_vm._v("\n            "+_vm._s(_vm.$t("educationSystem.bread.three_content"))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"kinder_design_style"},[_c('span',{staticClass:"kinder_design_title_style"},[_vm._v("\n            "+_vm._s(_vm.$t("educationSystem.bread.fourth"))+"\n          ")]),_vm._v(" "),_c('span',{attrs:{"title":_vm.$t("educationSystem.bread.fourth_content")}},[_vm._v("\n            "+_vm._s(_vm.$t("educationSystem.bread.fourth_content"))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"look_more_style",staticStyle:{"margin-top":"0.1rem"},on:{"click":function($event){return _vm.toClick(0)}}},[_vm._v("\n        "+_vm._s(_vm.$t("educationSystem.bread.fifth"))+"\n        >\n      ")])]),_vm._v(" "),_c('img',{staticClass:"kinder_img_style",attrs:{"src":__webpack_require__("xmoX")}})]),_vm._v(" "),_c('div',{staticClass:"kinder_style1"},[_c('img',{staticClass:"kinder_imgTop_style",attrs:{"src":_vm.$t("educationSystem.imgArr")[1]}}),_vm._v(" "),_c('div',{staticClass:"kinder"},[_c('div',{staticClass:"kinder_title_style"},[_c('div',{staticClass:"kinder_title_style_item",attrs:{"title":_vm.$t("educationSystem.schoolEducation.firstArr")[1].title}},[_vm._v(_vm._s(_vm.$t("educationSystem.schoolEducation.firstArr")[1].title))])]),_vm._v(" "),_c('div',{staticClass:"kinder_content",staticStyle:{"margin-top":"0.52rem","height":"2.92rem"}},[_c('div',{staticClass:"kinder_content_style",attrs:{"title":_vm.$t("educationSystem.schoolEducation.firstArr")[1].content}},[_vm._v(_vm._s(_vm.$t("educationSystem.schoolEducation.firstArr")[1].content))])]),_vm._v(" "),_c('div',{staticClass:"look_more_style",on:{"click":function($event){return _vm.toClick(1)}}},[_vm._v(_vm._s(_vm.$t("educationSystem.bread.fifth"))+">")])]),_vm._v(" "),_c('img',{staticClass:"kinder_img_style",attrs:{"src":__webpack_require__("ghFK")}})]),_vm._v(" "),_c('div',{staticClass:"kinder_style1",staticStyle:{"margin-bottom":"1.26rem"}},[_c('img',{staticClass:"kinder_imgTop_style",attrs:{"src":_vm.$t("educationSystem.imgArr")[2]}}),_vm._v(" "),_c('div',{staticClass:"kinder"},[_c('div',{staticClass:"kinder_title_style"},[_c('div',{staticClass:"kinder_title_style_item",attrs:{"title":_vm.$t("educationSystem.schoolEducation.firstArr")[2].title}},[_vm._v(_vm._s(_vm.$t("educationSystem.schoolEducation.firstArr")[2].title))])]),_vm._v(" "),_c('div',{staticClass:"kinder_content",staticStyle:{"margin-top":"0.52rem","height":"2.92rem"}},[_c('div',{staticClass:"kinder_content_style",attrs:{"title":_vm.$t("educationSystem.schoolEducation.firstArr")[2].content}},[_vm._v(_vm._s(_vm.$t("educationSystem.schoolEducation.firstArr")[2].content))])]),_vm._v(" "),_c('div',{staticClass:"look_more_style",on:{"click":function($event){return _vm.toClick(2)}}},[_vm._v(_vm._s(_vm.$t("educationSystem.bread.fifth"))+">")])]),_vm._v(" "),_c('img',{staticClass:"kinder_img_style",attrs:{"src":__webpack_require__("Jyqa")}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var system_inSchool = (esExports);
// CONCATENATED MODULE: ./src/components/system/inSchool.vue
function injectStyle (ssrContext) {
  __webpack_require__("pfbH")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60f3d05d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  inSchool,
  system_inSchool,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_system_inSchool = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Jyqa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/midSchool.4ebf838.png";

/***/ }),

/***/ "ghFK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/smallSchool.14beca2.png";

/***/ }),

/***/ "pfbH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xmoX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kindergarten.4cc9d5d.png";

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.786888f90bbc541b4bde.js